import { MAP_SET_ADDRESS, MAP_SET_LOCATIONNAME } from './mapActionTypes';
const log = require('../../components/shared/helper/MartLogger.js').logger;


const initState = {
    address: JSON.parse(localStorage.getItem('fkAddress')) || null, 
    locationName: JSON.parse(localStorage.getItem('fkAddress'))!== null ?  JSON.parse(localStorage.getItem('fkAddress')).formattedAddress : null, 
}

const mapReducer= (state = initState, action)=>{
    
    log("mapReducer - initial state:", state)    
    log("mapReducer - action:", action)

    if(action.type === MAP_SET_ADDRESS){  
        state.address = action.address;
        localStorage.setItem('fkAddress', JSON.stringify(state.address));
        //console.log("mapReducer - localStorage",JSON.parse(localStorage.getItem('fkAddress')))
        log("action type, updated state: ", state)
        //console.log("JSON.stringify updated state: ", JSON.stringify(state))
        return{
                ...state, 
        }
    }else if(action.type === MAP_SET_LOCATIONNAME){
        state.locationName = action.locationName;
        return{
                ...state, 
        }
    }
   
    else{
     return state;   
    }
}
export default mapReducer;